// ensure the objects in this file are the SAME as backend

export const errorConfig = {
  disallowAccessTokensWithUserAuthYoungerThanUtcMilli: {
    code: "disallowAccessTokensWithUserAuthYoungerThanUtcMilli",
    message: "User access token was authed before black list date",
  },
};
